import EntityService from './EntityService'
import { Bill, billConverter, BillPayment,billPaymentConverter } from '@/models/bill'
import { collection, deleteDoc, doc, getDocs, setDoc } from 'firebase/firestore'
import FirebaseService from './FirebaseService'


export default class BillService extends EntityService<Bill> {
  constructor() {
    super({ collectionName: 'bills', converter: billConverter })
  }

  async getBillPayments(billId: string): Promise<BillPayment[]> {
    const db = await FirebaseService.firestore()
    const billCollection = (await this.getCollection()).path
    const collectionRef = collection(db, `${billCollection}/${billId}/payments`).withConverter(billPaymentConverter)
    const docs = await getDocs(collectionRef)

    if (docs.empty) return []
    return docs.docs.map((doc) => doc.data() as BillPayment)
  }

  async addBillPayment (billId: string, payment: BillPayment): Promise<BillPayment> {
    const db = await FirebaseService.firestore()
    const billCollection = (await this.getCollection()).path
    const collectionRef = collection(db, `${billCollection}/${billId}/payments`).withConverter(billPaymentConverter)
    const docRef = doc(collectionRef)
    payment.id = docRef.id
    await setDoc(docRef, payment)

    return payment
  }

  async deleteBillPayment(billId: string, paymentId: string): Promise<Boolean> {
    const db = await FirebaseService.firestore()
    const billCollection = (await this.getCollection()).path
    const collectionRef = collection(db, `${billCollection}/${billId}/payments`).withConverter(billPaymentConverter)
    const docRef = doc(collectionRef, paymentId)
    await deleteDoc(docRef)
    return true
  }

  async getByPurchaseOrderId (id: string): Promise<Bill[]> {
    return await this.find_by('purchaseOrderId', '==', id)
  }

  async getByWorkOrderId (id: string): Promise<Bill[]> {
    return await this.find_by('workOrderId', '==', id)
  }

  async deleteByPurchaseOrderId (id: string): Promise<boolean> {
    const bills = await this.getByPurchaseOrderId(id)
    const allPromises = []
    bills.forEach((bill) => {
      allPromises.push(this.forceDelete(bill.id))
    })

    await Promise.all(allPromises)
    return true
  }

  async deleteByWorkOrderId (id: string): Promise<boolean> {
    const bills = await this.getByWorkOrderId(id)
    const allPromises = []
    bills.forEach((bill) => {
      allPromises.push(this.forceDelete(bill.id))
    })

    await Promise.all(allPromises)
    return true
  }

  async deleteBill (id: string): Promise<boolean> {
    // delete all payments
    const payments = await this.getBillPayments(id)
    const allPromises = payments.map((payment) => this.deleteBillPayment(id, payment.id))
    await Promise.all(allPromises)
    return await this.forceDelete(id)
  }
}
